
export default {
    data() {
        return {
            series: this.dataset.map(a => a.value),

            chartOptions: {
                chart: {
                    height: 350,
                    type: 'donut',
                    offsetY:10,
                },
                labels : this.dataset.map(a => a.name),
                responsive: [
                    {
                        breakpoint: 1024,
                        options: {
                            chart: {
                                width: '100%',
                                offsetY:0,
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    },
                    {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: '100%',
                            offsetY:0,
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
        };
    },
    props: {
        id: { type: String, default: 'pie-chart'},
        dataset : Array,
        title: String,
    },
};
